export function displayWithLineBreaks(text) {
  return text.split('\n').map((line, index, array) => (
    `${line}${index !== array.length - 1 ? '<br />' : ''}`
  )).join('');
}